<template>
  <div class="comprehensive-form-container">
    <el-row :gutter="20">
      <el-col
        :lg="{ span: 12, offset: 6 }"
        :md="{ span: 20, offset: 2 }"
        :sm="{ span: 20, offset: 2 }"
        :xl="{ span: 12, offset: 6 }"
        :xs="24"
      >
        <el-form
          ref="form"
          class="demo-form"
          :label-position="labelPosition"
          label-width="100px"
          :model="form"
          :rules="rules"
        >
          <el-form-item label="服务器地址" prop="url">
            <el-input v-model.trim="form.url" />
          </el-form-item>
          <el-form-item label="授权页地址" prop="authUrl">
            <el-input v-model.trim="form.authUrl" />
          </el-form-item>
          <el-form-item label="appKey" prop="appKey">
            <el-input v-model.trim="form.appKey" />
          </el-form-item>
          <el-form-item label="appSecret" prop="appSecret">
            <el-input v-model.trim="form.appSecret" show-password />
          </el-form-item>
          <el-form-item label="iv" prop="iv">
            <el-input v-model.trim="form.iv" show-password />
          </el-form-item>
          <el-form-item label="signKey" prop="signKey">
            <el-input v-model.trim="form.signKey" show-password />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm('form')">
              保存
            </el-button>
            <el-button @click="resetForm('form')">重置</el-button>
            <el-button type="warning" @click="refreshToken()">
              刷新Token
            </el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import {
    getGuanJiaPoConfig,
    setupGuanJiaPo,
    getGuanJiaPoAuthUrl,
    refreshGuanJiaPoToken,
  } from '@/api/settings'
  export default {
    name: 'GuanJiaPo',
    data() {
      return {
        getGuanJiaPoAuthUrl,
        labelPosition: 'right',
        form: {
          url: '',
          authUrl: '',
          appKey: '',
          appSecret: '',
          iv: '',
          signKey: '',
        },
        rules: {
          url: [],
          authUrl: [],
          appKey: [],
          appSecret: [],
          iv: [],
          signKey: [],
        },
      }
    },
    mounted() {
      this.getData()
      console.log('获取到的token:', this.$route.query)
      if(this.$route.query.auth_code){
        refreshGuanJiaPoToken({
          authCode: this.$route.query.auth_code,
        })
      }
    },
    methods: {
      async getData() {
        const ret = await getGuanJiaPoConfig()
        this.form.url = ret.basic.url
        this.form.authUrl = ret.basic.authUrl
        this.form.appKey = ret.basic.appKey
        this.form.appSecret = ret.basic.appSecret
        this.form.iv = ret.basic.iv
        this.form.signKey = ret.basic.signKey
      },
      submitForm(formName) {
        this.$refs[formName].validate(async (valid) => {
          if (valid) {
            await setupGuanJiaPo({
              config: this.form,
            })
            this.getData()
            this.$message.success('保存管家婆配置成功')
          } else {
            this.$message.success('保存管家婆配置失败')
            return false
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields()
      },
      async refreshToken() {
        const ret = await getGuanJiaPoAuthUrl({
          redirectUrl: 'https://id.qixiaoyun.com/#/settings/guanjiapo'
        })
        window.location.href = ret
      },
    },
  }
</script>

<style lang="scss" scoped>
  ::v-deep {
    .el-form-item__content {
      .el-rate {
        display: inline-block;
        font-size: 0;
        line-height: 1;
        vertical-align: middle;
      }

      .el-transfer__buttons {
        padding: 10px 10px 0 10px;
      }
    }
  }
  .title {
    color: #c3c3c3;
    padding-bottom: 10px;
    border-bottom: 1px solid #e3e3e3;
  }
</style>
